import React, {
    useState, useEffect, useCallback, useContext
} from 'react';
import { withRouter } from 'react-router-dom';
import { TranslatorContext } from '@jutro/locale';
import { renderContentFromMetadataInternal } from '@jutro/uiconfig';
import { ServiceRequestService } from 'gw-capability-servicerequest';
import { useAuthentication } from 'gw-digital-auth-react';
import {
    Loader,
} from '@jutro/components';
import _ from 'lodash';
import { ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import metadata from './ServiceRequestList_AX.metadata.json5';
import styles from './ServiceRequestList_AX.module.scss';
import messages from './ServiceRequestList_AX.messages';
import SearchPanelAX from '../../components/ServiceRequestListSearchPanelComponent_AX/ServiceRequestListSearchPanelComponent_AX';
import ServiceSummaryTableAX from '../../components/ServiceRequestSummaryTable_AX/ServiceRequestSummaryTable_AX';

function ServiceRequestList() {
    const translator = useContext(TranslatorContext);
    const { authHeader } = useAuthentication();
    const viewModelService = useContext(ViewModelServiceContext);
    const [isLoading, setLoadingState] = useState(false);
    const [newItems, setNewItems] = useState([]);
    const [openItems, setOpenItems] = useState([]);
    const [pendingPaymentItems, setPendingPaymentItems] = useState([]);
    const [closedItems, setClosedItems] = useState([]);
    const [allItems, setAllItem] = useState([]);
    const [dataReport, setDataReport] = useState([]);
    const [searchDTO, setSearchDTO] = useState([]);
    const [servicesList, setServicesList] = useState([]);
    const [showButton, setShowButton] = useState(false);

    const splitItems = useCallback((items) => {
        setNewItems(items.filter((item) => item.ax_GlobalStatus === 'new'));
        setOpenItems(items.filter((item) => item.ax_GlobalStatus === 'open'));
        setPendingPaymentItems(items.filter((item) => item.ax_GlobalStatus === 'pending_payment'));
        setClosedItems(items.filter((item) => item.ax_GlobalStatus === 'closed'));
    }, []);

    const receiveItems = useCallback((serviceRequestsItems) => {
        const servicesLocalList = [];
        let reportDatalList = [];
        setAllItem(serviceRequestsItems);
        splitItems(serviceRequestsItems);
        serviceRequestsItems.forEach((item) => {
            if (!servicesLocalList.find((tmp) => tmp.id === item.services[0])) {
                servicesLocalList.push({
                    displayName: item.services[0],
                    id: item.services[0]
                });
            }
        });
        reportDatalList = serviceRequestsItems.map((item) => (
            {
                createDate: (item.createDateString.replace('T', ' ')),
                serviceRequestNumber: item.serviceRequestNumber,
                claimID: item.claimID,
                nextStep: item.nextStep,
                defaultOperation: translator({
                    id: `typekey.ServiceRequestOperation.${item.defaultOperation}`,
                    defaultMessage: ''
                }),
                requestKind: translator({
                    id: `typekey.ServiceRequestKind.${item.requestKind}`,
                    defaultMessage: ''
                }),
                services: item.services,
                customerContact: item.customerContact,
                amountService: (
                    item.amountService.amount.toString().concat(' ').concat(item.amountService.currency)
                ),
                amountServiceInvoice: (
                    item.amountServiceInvoice.amount.toString().concat(' ').concat(item.amountServiceInvoice.currency)
                ),
                lastInvoiceStatus: translator({
                    id: `typekey.ServiceRequestInvoiceStatus.${item.lastInvoiceStatus}`,
                    defaultMessage: ''
                }),
                referenceInvoiceNumber: item.referenceInvoiceNumber,
                referenceInvoice: item.referenceInvoice
            }
        ));
        setServicesList(servicesLocalList);
        setDataReport(reportDatalList);
    }, [translator]);

    const receiveItemsFromPopup = useCallback((serviceRequestsResults) => {
        setShowButton(true);
        splitItems(serviceRequestsResults);
    }, []);

    const resetFilter = useCallback(async () => {
        setShowButton(false);
        splitItems(allItems);
    }, [allItems]);

    const onModelChanged = useCallback((model) => {
        let filteredData = allItems;
        if (model.progress.value !== undefined) {
            filteredData = filteredData.filter((item) => item.status === model.progress.value.code);
        }
        if (model.lossType.value !== undefined) {
            filteredData = filteredData.filter(
                (item) => item.ax_LossType === model.lossType.value.code
            );
        }
        if (model.serviceType.value !== undefined) {
            filteredData = filteredData.filter(
                (item) => item.services[0] === model.serviceType.value
            );
        }
        if (model.textSearch.value !== undefined && model.textSearch.value !== '') {
            const textSearch = model.textSearch.value.toLowerCase();
            filteredData = filteredData.filter(
                (item) => item.serviceRequestNumber.concat(
                    item.claimID, item.customerContact, item.nextStep
                ).toLowerCase().includes(textSearch)
            );
        }
        splitItems(filteredData);
        if (filteredData.length < allItems.length) {
            setShowButton(true);
        } else {
            setShowButton(false);
        }
    });

    const onPrintReport = useCallback((serviceReportDTO) => {
        let filteredDates = allItems;
        filteredDates = filteredDates.filter((item) => {
            let dateToValue = Date.parse(item.createDate);
            return (dateToValue >= Date.parse(serviceReportDTO.startDate)
            && dateToValue <= Date.parse(serviceReportDTO.endDate));
        });
    }, [allItems]);

    useEffect(() => {
        setLoadingState(true);
        if (!_.isUndefined(viewModelService)) {
            setSearchDTO(
                viewModelService.create({}, 'cc', 'edge.capabilities.servicerequest.dto.AXServiceRequestListSearchDTO')
            );
        }
        ServiceRequestService.getServiceRequestsForVendor(authHeader).then(
            receiveItems
        ).finally(() => {
            setLoadingState(false);
        });
    }, [authHeader, receiveItems, viewModelService]);

    if (isLoading) {
        return <Loader loaded={!isLoading} />;
    }

    const override = {
        searchPanel: {
            searchDTO: searchDTO,
            onModelChanged: onModelChanged,
            onPrintReport: onPrintReport,
            servicesList: servicesList,
            allItems: dataReport,
            authHeader: authHeader,
            receiveItems: receiveItems,
            receiveItemsFromPopup: receiveItemsFromPopup,
            resetFilter: resetFilter
        },
        tableNew: {
            dataArray: newItems
        },
        tableOpen: {
            dataArray: openItems
        },
        tablePendingPayment: {
            dataArray: pendingPaymentItems
        },
        tableClosed: {
            dataArray: closedItems
        },
        newOnesTab: {
            heading: translator(messages.newTabTitleMsg, { count: newItems.length })
        },
        openOnesTab: {
            heading: translator(messages.openTabTitleMsg, { count: openItems.length })
        },
        pendingPaymentOnesTab: {
            heading: translator(messages.pendingPaymentTabTitleMsg, {
                count: pendingPaymentItems.length
            })
        },
        closedOnesTab: {
            heading: translator(messages.closedTabTitleMsg, {
                count: closedItems.length
            })
        },
        filteredResultsWarning: {
            className: styles.buttonClass,
            visible: showButton,
            onClick: resetFilter
        },
    };

    const resolvers = {
        resolveComponentMap: {
            serviceSearchPanel: SearchPanelAX,
            serviceSummaryTable: ServiceSummaryTableAX,
            styles: styles
        }
    };

    return renderContentFromMetadataInternal(metadata.pageContent, override, resolvers);
}

export default withRouter(ServiceRequestList);
